/**
 * 语言管理工具函数
 *
 * 注意: 语言设置使用 localStorage 而不是 IndexedDB
 * 原因: 需要同步读取,在应用启动时立即可用
 */

import { SUPPORTED_LOCALES, type SupportedLocale } from '@/types/locale'

// 重新导出,方便其他地方使用
export type { SupportedLocale }
export { SUPPORTED_LOCALES }

const LOCALE_KEY = 'language'

/**
 * 获取浏览器语言
 */
export function getBrowserLanguage(): SupportedLocale {
  const language = navigator.language.toLowerCase()

  if (language.includes('zh')) return 'zh'
  if (language.includes('en')) return 'en'
  if (language.includes('ko')) return 'ko'
  if (language.includes('vi')) return 'vi'

  return 'zh' // 默认中文
}

/**
 * 获取存储的语言或浏览器语言
 */
export function getLocale(): SupportedLocale {
  const savedLocale = localStorage.getItem(LOCALE_KEY) as SupportedLocale | null

  if (savedLocale && SUPPORTED_LOCALES.includes(savedLocale)) {
    return savedLocale
  }

  return getBrowserLanguage()
}

/**
 * 设置语言
 */
export function setLocale(locale: SupportedLocale): void {
  if (!SUPPORTED_LOCALES.includes(locale)) {
    locale = 'zh'
  }

  localStorage.setItem(LOCALE_KEY, locale)
}

/**
 * 清除语言设置（使用浏览器语言）
 */
export function clearLocale(): void {
  localStorage.removeItem(LOCALE_KEY)
}
